import { ContactDetailsHeader, ContactDetailsViewBody } from "@tellescope/contact-details";
import { cn } from "@tellescope/design-system";
import { PAGE_HEADER_HEIGHT_CLASSES } from "../../../constants/header-sizing";
import { useContactDetailsSidebar, type ContactDetailsSidebarProps } from "./useContactDetailsSidebar";

export const ContactDetailsSidebar = (props: ContactDetailsSidebarProps) => {
  const { enduserId, setViewId, closeSidebar } = props;
  const {
    views,
    viewsAreLoading,
    resolvedViewId,
    defaultViewId,
    selectViewId,
    menuItems,
    blocksToHide,
    isFeatureEnabled,
    canUpdateObservations,
    onMaximizeBlock,
    onOpenTicket,
    onOpenEvent,
    onChangeEnduser,
  } = useContactDetailsSidebar(props);

  return (
    <>
      <ContactDetailsHeader
        enduserId={enduserId}
        views={views}
        viewsAreLoading={viewsAreLoading}
        selectedViewId={resolvedViewId}
        setSelectedViewId={selectViewId}
        defaultViewId={defaultViewId}
        closeSidebar={closeSidebar}
        menuItems={menuItems}
        className={cn(
          "border-b border-b-gray-200 flex justify-between items-center px-4 py-2",
          PAGE_HEADER_HEIGHT_CLASSES
        )}
      />
      {resolvedViewId && (
        <ContactDetailsViewBody
          viewId={resolvedViewId}
          enduserId={enduserId}
          onViewMaterialized={setViewId}
          isFeatureEnabled={isFeatureEnabled}
          canUpdateObservations={canUpdateObservations}
          onMaximizeBlock={onMaximizeBlock}
          blocksToHide={blocksToHide}
          className="h-[unset] grow min-h-0"
          onOpenTicket={onOpenTicket}
          onOpenEvent={onOpenEvent}
          onChangeEnduser={onChangeEnduser}
        />
      )}
    </>
  );
};
